/**
 * IP Product Info JS
 * Uses event delegation to work with dynamically loaded content (quick-view)
 */
(function() {
  'use strict';

  // Quantity buttons - event delegation
  document.addEventListener('click', function(e) {
    // Decrease quantity
    if (e.target.closest('[data-action="decrease-picker-quantity"]')) {
      var btn = e.target.closest('[data-action="decrease-picker-quantity"]');
      var container = btn.closest('.ip-pro-qty') || btn.closest('.ip-pro-info');
      var input = container.querySelector('.ip-pro-qty__input');
      if (input) {
        var current = parseInt(input.value) || 1;
        if (current > 1) {
          input.value = current - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
    
    // Increase quantity
    if (e.target.closest('[data-action="increase-picker-quantity"]')) {
      var btn = e.target.closest('[data-action="increase-picker-quantity"]');
      var container = btn.closest('.ip-pro-qty') || btn.closest('.ip-pro-info');
      var input = container.querySelector('.ip-pro-qty__input');
      if (input) {
        var current = parseInt(input.value) || 1;
        input.value = current + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    
    // Buy Now button
    if (e.target.closest('.ip-pro-buy-now-btn')) {
      var buyNowBtn = e.target.closest('.ip-pro-buy-now-btn');
      var infoContainer = buyNowBtn.closest('.ip-pro-info') || document;
      var form = infoContainer.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      
      if (form) {
        var variantInput = form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]');
        var qtyInput = infoContainer.querySelector('.ip-pro-qty__input') || document.querySelector('.ip-pro-qty__input');
        var variantId = variantInput ? variantInput.value : null;
        var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
        
        if (variantId) {
          buyNowBtn.disabled = true;
          buyNowBtn.textContent = 'PROCESSING...';
          
          fetch('/cart/clear.js', { method: 'POST' })
            .then(function() {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: qty })
              });
            })
            .then(function() {
              window.location.href = '/checkout';
            })
            .catch(function(err) {
              console.error('Buy Now error:', err);
              buyNowBtn.disabled = false;
              buyNowBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>BUY NOW';
            });
        }
      }
    }
    
    // Basket status quantity buttons
    if (e.target.closest('[data-action="basket-decrease"]') || e.target.closest('[data-action="basket-increase"]')) {
      var isDecrease = e.target.closest('[data-action="basket-decrease"]');
      var basketStatus = e.target.closest('.ip-basket-status');
      if (basketStatus) {
        var qtyVal = basketStatus.querySelector('.ip-basket-status__qty-val');
        var countText = basketStatus.querySelector('.ip-basket-count');
        var current = parseInt(qtyVal.value) || 1;
        
        if (isDecrease) {
          current = Math.max(0, current - 1);
        } else {
          current++;
        }
        
        if (current === 0) {
          // Remove from cart and show buy row again
          var buyRow = basketStatus.previousElementSibling;
          while (buyRow && !buyRow.classList.contains('ip-pro-buy-row')) {
            buyRow = buyRow.previousElementSibling;
          }
          if (buyRow) buyRow.classList.remove('is-hidden');
          basketStatus.classList.remove('is-active');
        }
        
        if (qtyVal) qtyVal.value = current;
        if (countText) countText.textContent = current;
      }
    }
  });

  // Per-metre total price update on quantity change
  document.addEventListener('change', function(e) {
    if (e.target.matches('.ip-pro-qty__input')) {
      var container = e.target.closest('.ip-pro-info') || document;
      var priceBlock = container.querySelector('.ip-pro-price-block');
      
      if (priceBlock && priceBlock.dataset.perMetre === 'true') {
        var qty = parseInt(e.target.value) || 1;
        var priceEl = container.querySelector('.ip-pro-price-current');
        var totalDiv = container.querySelector('.ip-pro-price-total');
        var totalValue = container.querySelector('.ip-pro-price-total-value');
        var qtyDisplay = container.querySelector('.ip-pro-qty-display');
        
        if (priceEl && totalDiv) {
          var priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
          var unitPrice = parseFloat(priceText) || 0;
          var total = (unitPrice * qty).toFixed(2);
          
          if (totalValue) totalValue.textContent = '£' + total;
          if (qtyDisplay) qtyDisplay.textContent = qty;
          totalDiv.style.display = qty > 1 ? 'block' : 'none';
        }
      }
    }
  });

  // Variant selection - price update
  document.addEventListener('change', function(e) {
    if (e.target.matches('.ip-pro-variant-select')) {
      var container = e.target.closest('.ip-pro-info') || document;
      var scriptEl = container.querySelector('[data-product-json]');
      
      if (!scriptEl) return;
      
      try {
        var productData = JSON.parse(scriptEl.textContent);
        var variants = productData.product ? productData.product.variants : productData.variants;
        if (!variants || !variants.length) return;
        
        // Get all selected options
        var selects = container.querySelectorAll('.ip-pro-variant-select');
        var selectedOptions = [];
        selects.forEach(function(select) {
          selectedOptions.push(select.value);
        });
        
        // Find matching variant
        var variant = null;
        for (var i = 0; i < variants.length; i++) {
          var match = true;
          for (var j = 0; j < selectedOptions.length; j++) {
            if (variants[i]['option' + (j + 1)] !== selectedOptions[j]) {
              match = false;
              break;
            }
          }
          if (match) {
            variant = variants[i];
            break;
          }
        }
        
        if (variant) {
          // Update label
          var label = e.target.closest('.ip-pro-variant-group');
          if (label) {
            var span = label.querySelector('.ip-pro-variant-label span');
            if (span) span.textContent = e.target.value;
          }
          
          // Update hidden select
          var hiddenSelect = container.querySelector('select[name="id"]');
          if (hiddenSelect) hiddenSelect.value = variant.id;
          
          // Update prices
          var priceEl = container.querySelector('.ip-pro-price-current');
          var wasEl = container.querySelector('.ip-pro-price-was');
          var excEl = container.querySelector('.ip-pro-price-exc');
          var badgeEl = container.querySelector('.ip-pro-savings-badge');
          
          function formatMoney(cents) {
            return '£' + (cents / 100).toFixed(2);
          }
          
          if (priceEl) priceEl.textContent = formatMoney(variant.price);
          if (excEl) excEl.textContent = 'Exc. VAT: ' + formatMoney(Math.round(variant.price / 1.2));
          
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            var savings = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
            if (wasEl) {
              wasEl.textContent = formatMoney(variant.compare_at_price);
              wasEl.style.display = '';
            }
            if (badgeEl) {
              badgeEl.textContent = 'SAVE ' + savings + '%';
              badgeEl.style.display = '';
            }
          } else {
            if (wasEl) wasEl.style.display = 'none';
            if (badgeEl) badgeEl.style.display = 'none';
          }
          
          // Update stock status
          var stockEl = container.querySelector('.ip-pro-status-item--stock, .ip-pro-status-item--outofstock');
          if (stockEl) {
            if (variant.available) {
              stockEl.classList.remove('ip-pro-status-item--outofstock');
              stockEl.classList.add('ip-pro-status-item--stock');
              stockEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>In Stock';
            } else {
              stockEl.classList.remove('ip-pro-status-item--stock');
              stockEl.classList.add('ip-pro-status-item--outofstock');
              stockEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>Out of Stock';
            }
          }
          
          // Update add button
          var addBtn = container.querySelector('.ip-pro-add-btn');
          if (addBtn) {
            if (variant.available) {
              addBtn.disabled = false;
              addBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>ADD TO BASKET';
            } else {
              addBtn.disabled = true;
              addBtn.innerHTML = 'SOLD OUT';
            }
          }
        }
      } catch(err) {
        console.error('Variant update error:', err);
      }
    }
  });

  // AJAX Add to Cart with basket status bar
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('form.product-form');
    if (!form) return;
    
    var container = form.closest('.ip-pro-info');
    if (!container) return;
    
    var addBtn = container.querySelector('.ip-pro-add-btn');
    var buyRow = container.querySelector('.ip-pro-buy-row');
    var basketStatus = container.querySelector('.ip-basket-status');
    
    if (!addBtn || !basketStatus) return;
    
    e.preventDefault();
    
    var originalBtnHTML = addBtn.innerHTML;
    addBtn.classList.add('is-loading');
    addBtn.innerHTML = '<span class="loading-text">ADDING...</span>';
    
    var formData = new FormData(form);
    var quantity = parseInt(formData.get('quantity')) || 1;
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var qtyVal = basketStatus.querySelector('.ip-basket-status__qty-val');
      var countText = basketStatus.querySelector('.ip-basket-count');
      
      if (qtyVal) qtyVal.value = quantity;
      if (countText) countText.textContent = quantity;
      
      if (buyRow) buyRow.classList.add('is-hidden');
      basketStatus.classList.add('is-active');
      
      updateCartCount();
      
      addBtn.classList.remove('is-loading');
      addBtn.innerHTML = originalBtnHTML;
    })
    .catch(function(err) {
      console.error('Add to cart error:', err);
      addBtn.classList.remove('is-loading');
      addBtn.innerHTML = originalBtnHTML;
      alert('Error adding to cart. Please try again.');
    });
  });
  
  function updateCartCount() {
    fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var selectors = '.cart-count, [data-cart-count], .header__cart-count, .cart-item-count, #ipuk-cart-count, .ipuk-mobile-nav__badge';
      document.querySelectorAll(selectors).forEach(function(el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
    });
  }
})();
